import http from './httpService';
import * as models from '../utils/models';

const endpoint: string = '/organisation/';

function createOrganization(
	data: any,
	onUploadProgress: models.ProgressChange
) {
	return http.post(endpoint + 'create-organisation', data, {
		onUploadProgress,
	});
}

function activateOrganization(organizationId: string) {
	return http.post(endpoint + 'activate/' + organizationId);
}

function editOrganization(
	id: string,
	data: any,
	onUploadProgress: models.ProgressChange
) {
	return http.put(endpoint + id, data, { onUploadProgress });
}

function deactivateOrganization(organizationId: string) {
	return http.post(endpoint + 'deactivate/' + organizationId);
}

function getAll() {
	return http.get(endpoint + 'organisations');
}

function getOrganizationDivision() {
	return http.get(endpoint);
}

function getOrganization(organizationId: string) {
	return http.get<models.Organization>(endpoint + organizationId);
}

function getNotificationRecipients(organizationId: string) {
	return http.get<{ recipients: models.NotificationRecipient[] }>(
		endpoint + organizationId + '/notification-recipients'
	);
}

function addNotificationRecipient(organizationId: string, userId: string) {
	return http.post(endpoint + organizationId + '/notification-recipients', { userId });
}

function removeNotificationRecipient(organizationId: string, recipientId: string) {
	return http.delete(
		endpoint + organizationId + '/notification-recipients/' + recipientId
	);
}

export {
	activateOrganization,
	addNotificationRecipient,
	createOrganization,
	deactivateOrganization,
	editOrganization,
	getAll,
	getNotificationRecipients,
	getOrganization,
	getOrganizationDivision,
	removeNotificationRecipient,
};
